// 16 maximally-distinct colors ordered by hue spread
// Adjacent entries are as different as possible so sequential assignment avoids similar neighbors
const PALETTE = [
  { bg: "hsl(210, 55%, 90%)", text: "hsl(210, 55%, 28%)", dot: "#5B9BD5" },  // blue
  { bg: "hsl(25, 65%, 88%)",  text: "hsl(25, 65%, 28%)",  dot: "#D98A4E" },  // orange
  { bg: "hsl(145, 45%, 88%)", text: "hsl(145, 45%, 26%)", dot: "#4CAF7A" },  // green
  { bg: "hsl(340, 50%, 90%)", text: "hsl(340, 50%, 30%)", dot: "#D6648A" },  // rose
  { bg: "hsl(55, 55%, 86%)",  text: "hsl(55, 55%, 26%)",  dot: "#B8A840" },  // gold
  { bg: "hsl(270, 40%, 90%)", text: "hsl(270, 40%, 30%)", dot: "#9370BD" },  // purple
  { bg: "hsl(180, 45%, 86%)", text: "hsl(180, 45%, 24%)", dot: "#4DB0B0" },  // teal
  { bg: "hsl(0, 50%, 90%)",   text: "hsl(0, 50%, 30%)",   dot: "#CC6B6B" },  // red
  { bg: "hsl(95, 40%, 88%)",  text: "hsl(95, 40%, 26%)",  dot: "#7AAF4C" },  // lime
  { bg: "hsl(300, 35%, 90%)", text: "hsl(300, 35%, 30%)", dot: "#B870B8" },  // magenta
  { bg: "hsl(38, 60%, 88%)",  text: "hsl(38, 60%, 26%)",  dot: "#CC9640" },  // amber
  { bg: "hsl(225, 45%, 90%)", text: "hsl(225, 45%, 30%)", dot: "#7080C7" },  // indigo
  { bg: "hsl(160, 40%, 88%)", text: "hsl(160, 40%, 24%)", dot: "#50A88A" },  // mint
  { bg: "hsl(15, 55%, 88%)",  text: "hsl(15, 55%, 28%)",  dot: "#CF7450" },  // burnt orange
  { bg: "hsl(75, 40%, 88%)",  text: "hsl(75, 40%, 26%)",  dot: "#96AF50" },  // olive
  { bg: "hsl(315, 40%, 90%)", text: "hsl(315, 40%, 30%)", dot: "#C76BAF" },  // pink
] as const;

export const COLOR_PALETTE_HEX = PALETTE.map((p) => p.dot);

/**
 * Given a list of all active values for a category,
 * returns a stable color for each value by sequential palette assignment.
 * Values get colors in the order they appear in `allValues`.
 */
export function buildColorMap(allValues: string[]): Map<string, { bg: string; text: string; dot: string }> {
  const map = new Map<string, { bg: string; text: string; dot: string }>();
  const seen = new Set<string>();
  let idx = 0;
  for (const v of allValues) {
    if (seen.has(v)) continue;
    seen.add(v);
    map.set(v, PALETTE[idx % PALETTE.length]);
    idx++;
  }
  return map;
}

// Fallback for standalone lookups (used when allValues list isn't available)
function hashString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

export function getOptionColor(label: string): { bg: string; text: string; dot: string } {
  const index = hashString(label) % PALETTE.length;
  return PALETTE[index];
}

export function getOptionColorFromHex(hex: string): { bg: string; text: string; dot: string } {
  return {
    bg: `${hex}22`,
    text: hex,
    dot: hex,
  };
}
